module.exports = __webpack_public_path__ + "img/icon_home_order_nor@2x.3ca7ac94.png";